import ZIcon from '../components/ZIcon'
import { ErrorIcon } from '../assets/icons'
import ZText from '../components/ZText'
import ZScreenContainer from '../components/ZScreenContainer'
import ZButton from '../components/ZButton'
import ZBottomContainer from '../components/ZBottomContainer'
import { ErrorCause } from '../util/errorCause'
import { assertNever } from '../util/assertNever'

const ErrorScreen = ({
  cause,
  onReload,
}: {
  cause: ErrorCause
  onReload: () => void
}) => {
  const renderBody = () => {
    switch (cause) {
      case 'badUrl':
        return (
          <ZText variant="h6" textAlign="center">
            Something&apos;s not quite right here.
            <br />
            Please make sure the URL is valid.
          </ZText>
        )

      case 'invalidOrganisation':
        return (
          <ZText variant="h6" textAlign="center">
            Something&apos;s not quite right with this link.
            <br />
            Please close this page and open it again from the app you came from.
          </ZText>
        )

      case 'recoverable':
        return (
          <>
            <ZText variant="h6" textAlign="center">
              Something&apos;s gone wrong on our end.
              <br />
              Please try reloading the page.
            </ZText>

            <ZBottomContainer>
              <ZButton onClick={onReload}>Reload</ZButton>
            </ZBottomContainer>
          </>
        )

      // Exhaustiveness guard (mirrors home.tsx's Step + assertNever) — an unwired cause fails loudly, not silently.
      default:
        return assertNever(
          cause,
          <ZText variant="h6" textAlign="center">
            Something&apos;s gone wrong.
          </ZText>,
        )
    }
  }

  return (
    <ZScreenContainer>
      <ZIcon Icon={ErrorIcon} />
      {renderBody()}
    </ZScreenContainer>
  )
}

export default ErrorScreen
